import warning, { resetWarned } from '../vc-util/warning';

export { resetWarned };

export default (function (valid, component) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  warning(valid, '[antdv: ' + component + '] ' + message);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/warning.js
// module id = 36
// module chunks = 0